<button type="button" class="button-for-promo" (click)="openVideo()">
    <img src="/assets/images/youtube.png"> {{ text }}
</button>
